import { SxProps } from '@mui/joy/styles/types';

import { ExpandableList } from 'core/components';
import { INote } from 'core/types';

import { Note } from './Note';
import { IManagedNote, INoteProps } from './types';

interface IProps {
  notes: IManagedNote[];
  noteProps?: INoteProps;
  maxItems?: number;
  wrapperSx?: SxProps;
}

const DEFAULT_MAX_ITEMS = 10;

export const Notes = ({
  notes = [],
  noteProps = {},
  wrapperSx,
  maxItems = DEFAULT_MAX_ITEMS,
}: IProps) => {
  const {
    onSubmitEditNote = null,
    onDeleteNote = null,
    textEllipsis = false,
    displayCard = true,
    displayActions = true,
  } = noteProps;

  const handleOnSubmitEditNote = async (data: Partial<INote>) => {
    if (!onSubmitEditNote) {
      return { success: false };
    }

    const result = await onSubmitEditNote(data);
    const { success } = result || { success: false };

    return { success };
  };

  const handleOnDeleteNote = async (note: Partial<INote>) => {
    if (!onDeleteNote) {
      return;
    }

    await onDeleteNote(note);
  };

  if (notes.length === 0) {
    return <></>;
  }

  return (
    <ExpandableList<INote>
      items={notes}
      itemRenderer={(note: IManagedNote) => (
        <Note
          note={note}
          onSubmitEditNote={handleOnSubmitEditNote}
          onDeleteNote={handleOnDeleteNote}
          textEllipsis={textEllipsis}
          displayCard={displayCard}
          displayActions={displayActions}
        />
      )}
      marker={null}
      maxItems={maxItems}
      sx={{
        gap: displayCard ? 2 : 1,
        ...wrapperSx,
      }}
    />
  );
};
